import { fg } from '@atlassian/jira-feature-gating';

const AutoManagedSprintsForHarmonisedBoard = {
	get(): boolean {
		return fg('auto-managed_sprints_for_tmp_harmonised_board');
	},
};

export default AutoManagedSprintsForHarmonisedBoard;
